<script setup lang="ts">
import ProductCard from '@storefront-satch/components/molecules/product/card/ProductCard.vue'
import ProductCardContent from '@storefront-satch/components/molecules/product/card/ProductCardContent.vue'
import ProductImage from '@storefront-satch/components/molecules/product/card/ProductImage.vue'
import type { ProductGridProps } from '@storefront-satch/components/organisms/product/types'

const props = defineProps<ProductGridProps>()
</script>

<template>
  <div
    class="sm:gap-12.5 sm sm:mb-12.5 mb-12 grid grid-cols-2 gap-12 gap-x-2.5 transition-all sm:grid-cols-4 sm:gap-x-5"
    :class="props.class"
  >
    <slot />
    <template
      v-for="(product, index) in props.products"
      :key="index"
    >
      <div
        :data-el-id="`grid-item-${index}`"
        :data-product-id="product.variants[0].sku"
        class="product-grid-item max-xs:has-[+_.category-media-between]:self-center isolate"
      >
        <ProductCard
          :product="product"
          :show-wishlist-add-button="props.showWishlistAddButton"
          :show-wishlist-remove-button="props.showWishlistRemoveButton"
        >
          <template #image>
            <ProductImage
              :product="product"
              :alternate-images="false"
              :loading="index < 3 ? 'eager' : 'lazy'"
              :fetchpriority="index < 3 ? 'high' : undefined"
              :use-thumbhash="props.useThumbhash"
            />
          </template>

          <template #content="{ price, isOffer, originalPrice, currencyCode }">
            <ProductCardContent
              :product="product"
              :variant="props.variant"
              :price="price"
              :currency-code="currencyCode"
              :is-offer="isOffer"
              :original-price="originalPrice"
              :is-coming-soon-launch="product.isComingSoonLaunch"
              :is-coming-soon-restock="product.isComingSoonRestock"
              :is-coming-soon="product.isComingSoon"
              :launch-date="product.launchDate"
              :restock-date="product.restockDate"
              :show-edition="product.showEdition"
            />
          </template>
        </ProductCard>
      </div>
      <slot :name="`grid-item-${index}`" />
    </template>
  </div>
</template>
